module.exports = __webpack_public_path__ + "static/media/004_api_universe_whole.f3c8c0ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/004_api_universe_whole.png
// module id = 475
// module chunks = 0